// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modalSensorReplace__o9xwS {
  height: 464px;
  width: 372px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.biggerModal__RiY9R {
  width: 720px;
  height: 550px;
}

.infoLine__xzO_7 {
  display: flex;
  align-items: center;
  margin-bottom: 26px;
  padding: 10px 25px;
  border-top: 1px solid var(--tables-title-stroke);
  border-bottom: 1px solid var(--tables-title-stroke);
  background: var(--tables-title-surface);
}

.infoLineText__iyuWu {
  color: var(--tables-title-text);
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  text-transform: uppercase;
}
@media (max-width: 850px) {
  .infoLineText__iyuWu {
    font-size: 10px;
    line-height: 12px;
  }
}

.modalBody__EGslb {
  height: 100%;
  flex: 1;
  flex-direction: column;
  align-items: center;
  padding: 20px 51px 0;
}

.modalBodySecond__MmPb6 {
  padding: 0 25px;
}

.modalFooter__si9Np {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 20px;
  padding: 0 51px 20px;
}

.modalFooterSecond__yenup {
  flex-direction: row-reverse;
  align-items: center;
  gap: 25px;
  margin-top: 15px;
  padding: 0 25px 25px;
}`, "",{"version":3,"sources":["webpack://./../src/components/modals/SensorReplaceModal/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,aAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AAzEF;;AA4EA;EACE,YAAA;EACA,aAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gDAAA;EACA,mDAAA;EACA,uCAAA;AAzEF;;AA4EA;EACE,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;AAzEF;AA2EE;EARF;IASI,eAAA;IACA,iBAAA;EAxEF;AACF;;AA2EA;EACE,YAAA;EACA,OAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;AAxEF;;AA2EA;EACE,eAAA;AAxEF;;AA2EA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;EACA,oBAAA;AAxEF;;AA2EA;EACE,2BAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,oBAAA;AAxEF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.modalSensorReplace {\n  height: 464px;\n  width: 372px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.biggerModal {\n  width: 720px;\n  height: 550px;\n}\n\n.infoLine {\n  display: flex;\n  align-items: center;\n  margin-bottom: 26px;\n  padding: 10px 25px;\n  border-top: 1px solid var(--tables-title-stroke);\n  border-bottom: 1px solid var(--tables-title-stroke);\n  background: var(--tables-title-surface);\n}\n\n.infoLineText {\n  color: var(--tables-title-text);\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 14px;\n  text-transform: uppercase;\n\n  @media (max-width: 850px) {\n    font-size: 10px;\n    line-height: 12px;\n  }\n}\n\n.modalBody {\n  height: 100%;\n  flex: 1;\n  flex-direction: column;\n  align-items: center;\n  padding: 20px 51px 0;\n}\n\n.modalBodySecond {\n  padding: 0 25px;\n}\n\n.modalFooter {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  margin-top: 20px;\n  padding: 0 51px 20px;\n}\n\n.modalFooterSecond {\n  flex-direction: row-reverse;\n  align-items: center;\n  gap: 25px;\n  margin-top: 15px;\n  padding: 0 25px 25px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalSensorReplace": `modalSensorReplace__o9xwS`,
	"biggerModal": `biggerModal__RiY9R`,
	"infoLine": `infoLine__xzO_7`,
	"infoLineText": `infoLineText__iyuWu`,
	"modalBody": `modalBody__EGslb`,
	"modalBodySecond": `modalBodySecond__MmPb6`,
	"modalFooter": `modalFooter__si9Np`,
	"modalFooterSecond": `modalFooterSecond__yenup`
};
module.exports = ___CSS_LOADER_EXPORT___;
